import { useQuery, useQueryClient } from '@tanstack/react-query';

import { bankFeedApi } from '@/domain/bankFeed/api';
import type { EndpointBody } from '@/services/api';
import { queryOptions, useApiMutation } from '@/services/query';
import { handleErrorResponseWithToast, yieldSuccessNotification } from '@/lib/toasts';
import { bankFeedKeys } from '@/domain/bankFeed/queries/keys';

export const bankFeedSyncSchedulesQuery = (companyId: string) =>
  queryOptions({
    queryKey: bankFeedKeys.syncSchedules(companyId),
    queryFn: () => bankFeedApi.getSyncSchedules(),
  });

export const useBankFeedSyncSchedules = (companyId: string) => useQuery(bankFeedSyncSchedulesQuery(companyId));

export const useUpdateBankFeedSyncSchedulesMutation = (companyId: string) => {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (vars: { body: EndpointBody<typeof bankFeedApi.updateSyncSchedules> }) =>
      bankFeedApi.updateSyncSchedules({ body: vars.body }),
    onSuccess: (response) => {
      qc.setQueryData(bankFeedKeys.syncSchedules(companyId), response);
      yieldSuccessNotification({
        id: 'configurations.company.bankFeed.tabs.sync.toast.update.success',
        defaultMessage: 'Sync settings successfully updated',
      });
    },
    onError: handleErrorResponseWithToast,
  });
};
